import { ISchool, ISchoolData, ITableRes, ITimetable, ITimetableData, ITimetableParams } from 'types'

import { baseApi } from './baseApi'

export const mySchoolAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_mySchool: builder.query<ISchool, void>({
      query: () => ({
        url: '/my-school/',
      }),
      providesTags: ['school']
    }),
    PATCH_mySchool: builder.mutation<ISchool, ISchoolData>({
      query: (body) => ({
        url: '/my-school/',
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: ['school'],
    }),
    DELETE_mySchoolLogo: builder.mutation<ISchool, {}>({
      query: () => ({
        url: `/my-school/logo/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['school'],
    }),
    POST_mySchoolLogo: builder.mutation<ISchool, { formData: any }>({
      query: ({formData}) => ({
        url: `/my-school/logo/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['school'],
    }),    
    GET_myGradeLevels: builder.query<any, void>({
      query: () => ({
        url: '/my-grade-levels/',
      }),
      providesTags: ['grade-levels'],
    }),
    GET_timetables: builder.query<ITableRes<ITimetable>, ITimetableParams>({
      query: (params) => ({
        url: '/timetables/',
        params,
      }),
      providesTags: ['timetables'],
    }),
    GET_timetableById: builder.query<ITimetable, string>({
      query: (id) => {
        return {
          url: `/timetables/${id}/`,
        }
      },
      providesTags: ['timetable'],
    }),
    POST_timetable: builder.mutation<ITimetable, ITimetableData>({
      query: (body) => ({
        url: `/timetables/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['timetables'],
    }),
    POST_timetableSchedule: builder.mutation<ITimetable, { id: number, formData: any }>({
      query: ({id, formData}) => ({
        url: `/timetables/${id}/upload_schedule/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['timetable'],
    }),
    PUT_timetable: builder.mutation<ITimetable, { id: string; body: ITimetableData }>({
      query: ({ id, body }) => ({
        url: `/timetables/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['timetables', 'timetable'],
    }),
    DELETE_timetable: builder.mutation<ITimetable, string>({
      query: (id) => ({
        url: `/timetables/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['timetable'],
    }),
    DELETE_timetableSchedule: builder.mutation<ITimetable, number>({
      query: (id) => ({
        url: `/timetables/${id}/delete_schedule/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['timetable'],
    }),
  }),
})

export const {
  useGET_mySchoolQuery,
  usePATCH_mySchoolMutation,
  usePOST_mySchoolLogoMutation,
  useDELETE_mySchoolLogoMutation,
  useGET_myGradeLevelsQuery,
  useGET_timetablesQuery,
  useGET_timetableByIdQuery,
  usePOST_timetableMutation,
  usePUT_timetableMutation,
  useDELETE_timetableMutation,
  usePOST_timetableScheduleMutation,
  useDELETE_timetableScheduleMutation,
} = mySchoolAPI
